// Penn State University Park's undergraduate majors (#2596, founder 2026-09-30:
// "majors offered by the college in the public page"). Read on 2026-09-30 from the
// official 2026-2027 Undergraduate Bulletin (bulletins.psu.edu): the Programs
// finder filtered to Baccalaureate Degree and the University Park campus, each
// major then checked on its college's "Majors, Minors, and Certificates" tab,
// which is the source each group links. Majors at the other Commonwealth
// campuses, associate degrees, minors, certificates and the ROTC entries are
// left out. The Bulletin's "(Science)"-style suffixes, which only tell same-named
// programs apart, are dropped, and degrees lose their periods (B.S. becomes BS)
// to match the other files. Flags quote Penn State's first-year Requirements page
// (the college file's `requirements` source). The KB's majors list was the
// starting point; the Bulletin wins.
const majors = {
    "slug": "pennsylvania-state-university",
    "read": "2026-09-30",
    "intro": "Every bachelor's major Penn State's official Undergraduate Bulletin lists at University Park, grouped by the college that offers it, with the degree it leads to. Other campuses, minors and certificates are left out.",
    "groups": [
        {
            "name": "College of Agricultural Sciences",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Agricultural Sciences, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/agricultural-sciences/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Agribusiness Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural and Biorenewable Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural and Extension Education",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Science",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "Community, Environment, and Development",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Resource Management",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Forest Ecosystems",
                    "degree": "BS"
                },
                {
                    "name": "Immunology and Infectious Disease",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Contracting",
                    "degree": "BS"
                },
                {
                    "name": "Pharmacology and Toxicology",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Turfgrass Science",
                    "degree": "BS"
                },
                {
                    "name": "Veterinary and Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife and Fisheries Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Arts and Architecture",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Arts and Architecture, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/arts-architecture/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA",
                    "flag": "A prescreen, needed to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Architecture",
                    "degree": "BArch"
                },
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art Education",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Digital Arts and Media Design",
                    "degree": "BDes"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BDes",
                    "flag": "Evidence of Creative Work, needed to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Integrative Arts",
                    "degree": "BA"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Music",
                    "degree": "BA",
                    "flag": "A School of Music audition, which you schedule to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music",
                    "degree": "BM",
                    "flag": "A School of Music audition, which you schedule to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music Education",
                    "degree": "BME",
                    "flag": "A School of Music audition, which you schedule to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music Technology",
                    "degree": "BM",
                    "flag": "A School of Music audition, which you schedule to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Musical Arts",
                    "degree": "BMA",
                    "flag": "A School of Music audition, which you schedule to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA",
                    "flag": "A prescreen, needed to complete the application.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Professional Photography",
                    "degree": "BDes"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA",
                    "flag": "A prescreen, needed to complete the application.",
                    "flagSource": "requirements"
                }
            ]
        },
        {
            "name": "Donald P. Bellisario College of Communications",
            "source": {
                "label": "Penn State Undergraduate Bulletin, Donald P. Bellisario College of Communications, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/bellisario-communications/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Advertising/Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Film Production",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Telecommunications and Media Industries",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Earth and Mineral Sciences",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Earth and Mineral Sciences, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/earth-mineral-sciences/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Earth Science and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Energy Business and Finance",
                    "degree": "BS"
                },
                {
                    "name": "Energy Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geobiology",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geosciences",
                    "degree": "BA"
                },
                {
                    "name": "Geosciences",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Meteorology and Atmospheric Science",
                    "degree": "BS"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Petroleum and Natural Gas Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability, Society, and Environmental Geography",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Eberly College of Science",
            "source": {
                "label": "Penn State Undergraduate Bulletin, Eberly College of Science, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/eberly-science/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Data Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Integrative Science",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Neurobiology",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Planetary Science and Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Premedical-Medical",
                    "degree": "BS",
                    "flag": "A one-page resume and answers to program questions; SAT or ACT scores are mandatory for this program.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Premedicine",
                    "degree": "BS"
                },
                {
                    "name": "Science/Business Administration",
                    "degree": "BS/MBA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Education, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/education/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Education and Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Elementary and Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary and Kindergarten Education",
                    "degree": "BS"
                },
                {
                    "name": "Middle Level Education",
                    "degree": "BS"
                },
                {
                    "name": "Rehabilitation and Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BS"
                },
                {
                    "name": "Special Education",
                    "degree": "BS"
                },
                {
                    "name": "Workforce Education and Development",
                    "degree": "BS"
                },
                {
                    "name": "World Languages (K-12) Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Engineering, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/engineering/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BAE"
                },
                {
                    "name": "Artificial Intelligence Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Health and Human Development",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Health and Human Development, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/health-human-development/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Biobehavioral Health",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Health Policy and Administration",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Recreation, Park, and Tourism Management",
                    "degree": "BS"
                },
                {
                    "name": "Systems Neuroscience",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Information Sciences and Technology",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of Information Sciences and Technology, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/information-sciences-technology/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence Methods and Applications",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity Analytics and Operations",
                    "degree": "BS"
                },
                {
                    "name": "Data Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Enterprise Technology Integration",
                    "degree": "BS"
                },
                {
                    "name": "Human-Centered Design and Development",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology Ethics and Compliance",
                    "degree": "BS"
                },
                {
                    "name": "Security and Risk Analysis",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Intercollege Programs",
            "source": {
                "label": "Penn State Undergraduate Bulletin, Intercollege Programs, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/intercollege/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Bachelor of Philosophy Degree",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of the Liberal Arts",
            "source": {
                "label": "Penn State Undergraduate Bulletin, College of the Liberal Arts, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/liberal-arts/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "African and African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "African and African American Studies",
                    "degree": "BS"
                },
                {
                    "name": "African Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropological Science",
                    "degree": "BS"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics and Ancient Mediterranean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Arts and Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Communication Arts and Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BA"
                },
                {
                    "name": "Criminology",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BS"
                },
                {
                    "name": "Global and International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global and International Studies",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Politics",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BS"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Korean",
                    "degree": "BA"
                },
                {
                    "name": "Labor and Human Resources",
                    "degree": "BA"
                },
                {
                    "name": "Labor and Human Resources",
                    "degree": "BS"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Medieval Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle East Studies",
                    "degree": "BA"
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Social Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BS"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Ross and Carol Nese College of Nursing",
            "source": {
                "label": "Penn State Undergraduate Bulletin, Ross and Carol Nese College of Nursing, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/nursing/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Smeal College of Business",
            "source": {
                "label": "Penn State Undergraduate Bulletin, Smeal College of Business, Majors, Minors, and Certificates",
                "url": "https://bulletins.psu.edu/undergraduate/colleges/smeal-business/#majorsminorsandcertificatestext"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics and Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Corporate Innovation and Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                },
                {
                    "name": "Risk Management",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain and Information Systems",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
